export default {
  instruction: {
    header: 'Instructions',
    rate: '”Rate the instruction” notifications',
    rateFrequency: 'Frequency',
    duration: 'Time range',
  },
};
